import Vue from 'vue'
import Vuex from 'vuex'

import { STORAGE_COUNTRY_KEY } from '@/constants'

import authModule from './modules/auth'
import uiModule from './modules/ui'
import accrualsModule from './modules/accruals'
import offersModule from './modules/offers'
import cardsModule from './modules/cards'
import randomRewards from './modules/random-rewards'
import extraBonus from './modules/extra-bonus'
import api from '@/common/api/cobrandApiClient'

Vue.use(Vuex)

const SET_COUNTRY = 'SET_COUNTRY'
const SET_RANDOM_BUTTON_DATA = 'SET_RANDOM_BUTTON_DATA'
const ERROR_RANDOM_BUTTON_DATA = 'ERROR_RANDOM_BUTTON_DATA'

const SET_PAGE_CONTENT = 'SET_PAGE_CONTENT'
const ERROR_PAGE_CONTENT = 'ERROR_PAGE_CONTENT'

const SET_DESIGNS = 'SET_DESIGNS'
const ERROR_DESIGNS_DATA = 'ERROR_DESIGNS_DATA'

export default new Vuex.Store({
  strict: process.env.NODE_ENV !== 'production',
  state: {
    country: localStorage.getItem(STORAGE_COUNTRY_KEY) || null,
    randomButtonData: null,
    randomButtonError: null,
    pagesContent: null,
    designs: null,
    designsError: null
  },
  getters: {
    currentPageContent (state) {
      const { pathname } = window.location
      if (!state.pagesContent) return null
      if (!state.pagesContent.data || !state.pagesContent.data.length) return null
      try {
        const { content } = state.pagesContent.data.find((item) => {
          return pathname === item.path
        })
        return JSON.parse(content)
      } catch (err) {
        return null
      }
    }
  },
  mutations: {
    [SET_COUNTRY] (state, country) {
      state.country = country
    },
    [SET_RANDOM_BUTTON_DATA] (state, data) {
      state.randomButtonData = data
    },
    [ERROR_RANDOM_BUTTON_DATA] (state, error) {
      state.randomButtonData = null
      state.randomButtonError = error
    },
    [SET_PAGE_CONTENT] (state, data) {
      state.pagesContent = { ...data }
    },
    [ERROR_PAGE_CONTENT] (state) {
      state.pagesContent = null
    },
    [SET_DESIGNS] (state, designs) {
      state.designs = designs
    },
    [ERROR_DESIGNS_DATA] (state, error) {
      state.designsError = error
    }
  },
  actions: {
    changeCountry ({ commit }, country) {
      commit(SET_COUNTRY, country)
      localStorage.setItem(STORAGE_COUNTRY_KEY, country)
    },
    async getButtonData ({ commit }) {
      try {
        const { data } = await api.getRandomButton()
        commit(SET_RANDOM_BUTTON_DATA, data)
      } catch (error) {
        commit(ERROR_RANDOM_BUTTON_DATA, error)
      }
    },
    async getPageContent ({ commit }) {
      try {
        const { data } = await api.getPageContent()
        commit(SET_PAGE_CONTENT, data)
      } catch (error) {
        commit(ERROR_PAGE_CONTENT, error)
      }
    },
    async getCardDesigns ({ commit }) {
      try {
        const designs = await api.getCardDesigns()
        commit(SET_DESIGNS, designs)
      } catch (error) {
        commit(ERROR_DESIGNS_DATA, error)
      }
    }
  },
  modules: {
    auth: authModule,
    ui: uiModule,
    accruals: accrualsModule,
    offers: offersModule,
    cards: cardsModule,
    randomRewards,
    extraBonus
  }
})
